// src/components/AuthForm.jsx
import React, { useState } from 'react';
import './AuthForm.css';

const AuthForm = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!credentials.username || !credentials.password) {
      setError('Please enter both username and password');
      return;
    }

    setIsLoading(true);
    try {
      const result = await onLogin(credentials);
      if (!result) {
        setError('Invalid credentials. Please try again.');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('An error occurred during login. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        {/* Left branding panel */}
        <div className="auth-branding">
          <div className="branding-content">
            <div className="branding-logo">S</div>
            <h1 className="branding-title">Welcome to ScheduleWise</h1>
            <p className="branding-subtitle">
              The smart way to manage your football club's pitch bookings and training sessions.
            </p>
            <ul className="branding-features">
              <li>
                <span className="feature-icon">📅</span>
                Easy booking management
              </li>
              <li>
                <span className="feature-icon">👥</span>
                Team coordination
              </li>
              <li>
                <span className="feature-icon">📊</span>
                Schedule visibility
              </li>
              <li>
                <span className="feature-icon">⚡</span>
                Real-time updates
              </li>
            </ul>
          </div>
        </div>

        {/* Right form panel */}
        <div className="auth-form-panel">
          <div className="auth-form-header">
            <div className="auth-form-icon">S</div>
            <h2 className="auth-form-title">Sign In</h2>
            <p className="auth-form-subtitle">Enter your credentials to access your account</p>
          </div>

          {error && (
            <div className="auth-error">
              <span className="auth-error-icon">!</span>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="auth-form-group">
              <label className="auth-label" htmlFor="username">
                Username
              </label>
              <div className="auth-input-wrapper">
                <input
                  type="text"
                  id="username"
                  name="username"
                  className="auth-input"
                  value={credentials.username}
                  onChange={handleChange}
                  autoComplete="username"
                  placeholder="Enter your username"
                />
                <svg className="auth-input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
            </div>

            <div className="auth-form-group">
              <label className="auth-label" htmlFor="password">
                Password
              </label>
              <div className="auth-input-wrapper">
                <input
                  type="password"
                  id="password"
                  name="password"
                  className="auth-input"
                  value={credentials.password}
                  onChange={handleChange}
                  autoComplete="current-password"
                  placeholder="Enter your password"
                />
                <svg className="auth-input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
              </div>
            </div>

            <button
              type="submit"
              className="auth-submit-btn"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="auth-spinner"></span>
                  Signing in...
                </>
              ) : (
                <>
                  Sign In
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14"></path>
                    <path d="M12 5l7 7-7 7"></path>
                  </svg>
                </>
              )}
            </button>
          </form>

          <div className="auth-footer">
            Contact your club administrator if you need access.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthForm;
